export default {"src":"/_next/static/media/firewall.7e1a4387.svg","height":76,"width":76};